/* T&B sock facets: merge equivalent presentation labels, retain every original Shopify facet value. */
(function(){
  function labelKey(label){
    var s=(label||'').trim().replace(/\s+/g,' ').replace(/[‐‑‒–—]/g,'-').toUpperCase();
    var eu=s.match(/^EU\s*(\d{2})\s*[-/]\s*(\d{2})/);
    if(eu) return 'EU '+eu[1]+'-'+eu[2];
    // Recognise explicit UK ranges, plain UK sock ranges, and UK ranges in parentheses.
    var uk=s.match(/\bUK\s*(?:ADULT\s*)?(\d+(?:\.\d+)?)\s*[-/]\s*(\d+(?:\.\d+)?)/);
    if(!uk)uk=s.match(/^(\d+(?:\.\d+)?)\s*[-/]\s*(\d+(?:\.\d+)?)\s*(?:UK)?$/);
    if(uk && Number(uk[1])<35 && Number(uk[2])<35)return 'UK '+Number(uk[1])+'-'+Number(uk[2]);
    if(/^M\s*:/.test(s))return 'SIZE M';
    if(/^L\s*:/.test(s))return 'SIZE L';
    if(/^XL\s*:/.test(s))return 'SIZE XL';
    if(s==='XXL'||s==='2XL')return 'SIZE XXL';
    var compact=s.replace(/\s/g,'');
    if(['S','S/M','S-M','SM'].includes(compact))return 'SIZE S';
    if(['M','M/L','M-L','ML'].includes(compact))return 'SIZE M';
    if(compact==='L')return 'SIZE L';
    if(['XL','L/XL','L-XL','X-L'].includes(compact))return 'SIZE XL';
    return s;
  }
  function displayName(key,original){
    if(key==='SIZE S')return 'S';
    if(key==='SIZE M')return 'M';
    if(key==='SIZE L')return 'L';
    if(key==='SIZE XL')return 'XL';
    if(key==='SIZE XXL')return 'XXL';
    if(key.startsWith('EU '))return key.replace('-', '–');
    if(key.startsWith('UK '))return key.replace('-', '–');
    return original;
  }
  function refresh(){
    document.querySelectorAll('#CollectionFilterForm .tnb-sock-size-grid, #CollectionFilterForm .tnb-clothing-size-grid').forEach(function(grid){
      var groups=new Map();
      grid.querySelectorAll(':scope > label.filter-group__item').forEach(function(label){
        var input=label.querySelector('input[type="checkbox"]');
        var span=label.querySelector('.filter-group__item__text');
        if(!input||!span)return;
        var k=grid.classList.contains('tnb-clothing-size-grid') ? ((span.textContent.trim().toUpperCase()==='2XL'||span.textContent.trim().toUpperCase()==='XXL') ? 'SIZE XXL' : span.textContent.trim().toUpperCase()) : labelKey(span.textContent);
        var g=groups.get(k);
        if(!g){g={labels:[],inputs:[]};groups.set(k,g);}
        g.labels.push(label);g.inputs.push(input);
      });
      groups.forEach(function(g,k){
        var master=g.labels[0];if(!master)return;
        var span=master.querySelector('.filter-group__item__text');
        if(span && !span.dataset.tnbOriginalText) {
          span.dataset.tnbOriginalText=span.textContent.trim();
          var tick=span.querySelector('svg');span.textContent=displayName(k,span.dataset.tnbOriginalText);
          if(tick)span.appendChild(tick);
        }
        if(g.labels.length<2 && !k.startsWith('SIZE '))return;
        master.dataset.tnbMergedSize=k;
        var values=g.inputs.map(function(el){return {name:el.name,value:el.value,checked:el.checked};});
        master.dataset.tnbMergeValues=JSON.stringify(values);
        master.classList.toggle('filter-group__item--active',values.some(function(v){return v.checked;}));
        for(var i=1;i<g.labels.length;i++){g.labels[i].hidden=true;g.labels[i].classList.add('tnb-sock-size-duplicate');};
      });
    });
  }
  document.addEventListener('click',function(event){
    var label=event.target.closest('#CollectionFilterForm .tnb-sock-size-grid label[data-tnb-merged-size], #CollectionFilterForm .tnb-clothing-size-grid label[data-tnb-merged-size]');
    if(!label)return;
    event.preventDefault();event.stopPropagation();
    var options=JSON.parse(label.dataset.tnbMergeValues||'[]');
    if(!options.length)return;
    var url=new URL(window.location.href);
    var shouldRemove=options.some(function(x){return x.checked;});
    options.forEach(function(x){
      var remaining=url.searchParams.getAll(x.name).filter(function(y){return y!==x.value;});
      url.searchParams.delete(x.name);
      remaining.forEach(function(y){url.searchParams.append(x.name,y);});
    });
    if(!shouldRemove)options.forEach(function(x){url.searchParams.append(x.name,x.value);});
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);
  else refresh();
  document.addEventListener('shopify:section:load',refresh);
  // Watch only the filter panel, rather than the whole document, for AJAX re-renders.
  function observeFilterPanel(){
    var form=document.getElementById('CollectionFilterForm');
    if(!form)return;
    var root=form.parentElement;
    if(!root)return;
    var queued=false;
    new MutationObserver(function(records){
      if(!records.some(function(r){return Array.prototype.some.call(r.addedNodes,function(n){return n.nodeType===1 && (n.matches?.('.tnb-sock-size-grid,.tnb-clothing-size-grid,#CollectionFilterForm') || n.querySelector?.('.tnb-sock-size-grid,.tnb-clothing-size-grid'));});}))return;
      if(queued)return;
      queued=true;
      requestAnimationFrame(function(){queued=false;refresh();});
    }).observe(root,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observeFilterPanel);
  else observeFilterPanel();
})();
